import Cookie from 'js-cookie';
import { stringUriToBase64 } from './braintreeUtils.js';

const isQueryParamsPresentInUrl = (urlString, queryParams) => {
    const url = new URL(urlString);
    const extractedQueryParam = queryParams.map((queryParam) => {
        return url.searchParams.get(queryParam);
    });
    return extractedQueryParam.every((param) => !!param);
};
const isReturnUrlFromAdyen = (urlString) => {
    return isQueryParamsPresentInUrl(urlString, ['redirectResult', 'shopperStatement']);
};
const computeMobileReturnUrl = (mobileAppURLSchema, forceToNativeBrowser = false) => {
    if (forceToNativeBrowser) {
        return `${mobileAppURLSchema}${window.location.pathname}`;
    }
    return `${window.location.origin}${window.location.pathname}`;
};
const getOrderDetailsUrl = () => {
    const isPaymentResultUrl = isQueryParamsPresentInUrl(window.location.href, ['authResult']) ||
        isQueryParamsPresentInUrl(window.location.href, ['auth']);
    return isPaymentResultUrl
        ? window.location.href
        : `${window.location.origin}${window.location.pathname}`;
};
const getMobileAppsReturnUrl = (mobileAppURLSchema, forceToNativeBrowser = false) => {
    return computeMobileReturnUrl(mobileAppURLSchema, forceToNativeBrowser);
};
const encodePageUrlasBase64 = () => {
    return stringUriToBase64(getOrderDetailsUrl());
};
const isRecognizedApp = (value) => {
    return value && ['android', 'ios'].some((deviceType) => deviceType === value);
};
const getMobileAppType = () => {
    return Cookie.get('MOBILE_APP');
};

export { computeMobileReturnUrl, encodePageUrlasBase64, getMobileAppType, getMobileAppsReturnUrl, getOrderDetailsUrl, isRecognizedApp, isReturnUrlFromAdyen };
//# sourceMappingURL=retryUtils.js.map
